import { useTinyHost } from "@tiny/host-contract";

function useFeatureAvailability(featureSystemName: string) {
  const { capabilities, upsell } = useTinyHost();
  const hasAccess = capabilities.featuresLoading
    ? undefined
    : capabilities.isFeatureEnabled(featureSystemName);
  const requestUpgradeDialog = () =>
    upsell.showFeatureUpgrade({
      featureName:
        capabilities.featureDetails(featureSystemName)?.name ||
        featureSystemName,
    });
  return [hasAccess, requestUpgradeDialog] as const;
}

export { useFeatureAvailability };
